
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getVoucherRecognitionAddressDtoFormGroup() {
return new FormGroup({
    street: new FormControl<string | undefined>(''),
    postCode: new FormControl<string | undefined>(''),
    city: new FormControl<string | undefined>(''),
    countryId: new FormControl<string | undefined>(''),
})
;
}
      